import React from 'react';
import { Toolbar } from 'react-admin';
import { withStyles } from '@material-ui/core';

const styles = {
  toolbar:{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    backgroundColor: 'inherit',
    marginTop: '24px',
    padding: '10px 24px',
    borderTop: '2px solid rgba(178,178,178,0.5)'
  },
};

const StyledToolbar = ({classes, ...rest}) => <Toolbar className={classes.toolbar} {...rest}/>

export default withStyles(styles)(StyledToolbar)
